"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// Colors defined in https://www.figma.com/file/5scdIPqUQexPplM2dyyAB2/from-November-2019--to--June-2020?node-id=1%3A4
var colors = {
  primary: {
    light: '#9BB6D3',
    lightMain: '#386081',
    main: '#284D6B',
    darkMain: '#1A3A55',
    dark: '#05273D'
  },
  secondary: {
    light: '#D4FFE0',
    lightMain: '#7ADD99',
    main: '#44B55F',
    darkMain: '#287B3A',
    dark: '#155935'
  },
  error: {
    light: '#FFD6D6',
    lightMain: '#FFA3A3',
    main: '#FF6666',
    darkMain: '#D32526',
    dark: '#9E2F26'
  },
  warning: {
    light: '#FFF9D9',
    lightMain: '#FFE86B',
    main: '#FAD114',
    darkMain: '#EAB800',
    dark: '#CCA108'
  },
  info: {
    light: '#FFF9D9',
    lightMain: '#FFE86B',
    main: '#FAD114',
    darkMain: '#EAB800',
    dark: '#CCA108'
  },
  success: {
    light: '#D4FFE0',
    lightMain: '#7ADD99',
    main: '#44B55F',
    darkMain: '#287B3A',
    dark: '#155935'
  },
  additional: {
    light: '#D7F0FA',
    lightMain: '#9FE0FA',
    main: '#4DBCE9',
    darkMain: '#0D79A5',
    dark: '#274562'
  },
  "default": {
    light: '#EEEEEE',
    lightMain: '#BDBDBD',
    main: '#8A8A8A',
    darkMain: '#626262',
    dark: '#424242',
    contrastText: '#4C4C4C'
  },
  text: {
    title: "#424242",
    primary: "#616161",
    secondary: '#757575',
    disabled: '#BDBDBD',
    white: '#FFFFFF'
  },
  table: {
    header: '#EEEEEE'
  },
  elements: {
    border: '#BDBDBD',
    divider: '#BDBDBD',
    background: '#F5F5F5'
  }
};
var _default = colors;
exports["default"] = _default;